import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode } from 'react'

import { motionFadeIn } from '@apps-common/config/motion-variants'

interface IProps {
  key: string
  loading: boolean
  skeleton?: ReactNode
  children: ReactNode
  classes?: string
}

export const LoadingSwitcher: React.FC<IProps> = ({ key, loading, skeleton, children, classes }) => (
  <AnimatePresence mode='popLayout'>
    {loading && (
      <motion.div key={`${key}-skeleton`} {...motionFadeIn(0.2)} className={classes}>
        {skeleton}
      </motion.div>
    )}
    {!loading && (
      <motion.div key={`${key}`} {...motionFadeIn(0.2)} className={classes}>
        {children}
      </motion.div>
    )}
  </AnimatePresence>
)
